import React from "react";
import styled from "styled-components";
import Styles from "@themes/Styles";
import { ButtonSize, LifeAtButtonV2 } from "../LifeAtButtonV2/LifeAtButtonV2";

const TabContainer = styled.div<{ isActive: boolean; underlineColor?: UnderlineColor }>`
    border-bottom: ${(props) =>
        props.isActive
            ? `3px solid ${props.underlineColor === "red" ? Styles.lifeatSpecialRed : props.theme.textColorPrimary}`
            : `none`};
`;

type UnderlineColor = "red" | "default";

export interface TabProps {
    readonly isActiveTab: boolean;
    readonly handleSelect: () => void;
    readonly buttonSize?: ButtonSize;
    readonly underlineColor?: UnderlineColor;
    readonly label?: string;
    readonly icon?: React.ReactNode;
}
export default function Tab(props: TabProps) {
    return (
        <TabContainer isActive={props.isActiveTab} underlineColor={props.underlineColor}>
            <LifeAtButtonV2
                onClick={props.handleSelect}
                variant={"ghost"}
                size={props.buttonSize ?? "large"}
                disableHover={true}
            >
                {props.icon}
                {props.label}
            </LifeAtButtonV2>
        </TabContainer>
    );
}
